import React, { ReactNode } from 'react';
import { useQuery } from '@common/hooks';
import { ErrorHandler, LoadingState } from '@common/components';
import {
  CurrentMembershipContextQuery,
  CurrentMembershipContextQueryResponse,
  CurrentMembershipPermissionsType,
} from '@identity/graphql';

export const CurrentMembershipContext =
  React.createContext<CurrentMembershipPermissionsType | null>(null);

export const CurrentMembershipContextProvider = ({
  children,
}: {
  children: ReactNode | undefined;
}) => {
  const { data, loading, error } =
    useQuery<CurrentMembershipContextQueryResponse>(
      CurrentMembershipContextQuery,
      {
        fetchPolicy: 'cache-first',
      }
    );

  if (loading) {
    return <LoadingState />;
  }

  if (error || !data?.currentMembership) {
    return (
      <ErrorHandler error={error} log="CurrentMembershipContextProvider" />
    );
  }

  return (
    <CurrentMembershipContext.Provider value={data.currentMembership}>
      {children}
    </CurrentMembershipContext.Provider>
  );
};
